module.exports = __webpack_public_path__ + "img/7@2x-zh.68b1ec1.957fec73.png";